import * as hospitalData from "../../action/actiontype/HospitalType/Hospital";

const hospitalReducer = (state = {}, action) => {
  switch (action.type) {
    case hospitalData.HOSPITALLISTDATA:
      return {
        ...state,
        hospitalList: action.payload,
      };
    case hospitalData.HOSPITAL_PHARMACY_REQUEST:
      return {
        ...state,
        hospitalPharamacyLoading: true,
        hospitalPharamacyResponse: {},
        hospitalPharamacyError: null,
      };
    case hospitalData.HOSPITAL_PHARMACY_SUCCESS:
      return {
        ...state,
        hospitalPharamacyLoading: false,
        hospitalPharamacyResponse: action.payload,
        hospitalPharamacyError: null,
      };
    case hospitalData.HOSPITAL_PHARMACY_FAILURE:
      return {
        ...state,
        hospitalPharamacyLoading: false,
        hospitalPharamacyError: action.payload,
        hospitalPharamacyResponse: {},
      };

    case hospitalData.HOSPITAL_FACILITY_REQUEST:
      return {
        ...state,
        hospitalFacilityLoading: true,
        hospitalFacilityResponse: {},
        hospitalFacilityError: null,
      };
    case hospitalData.HOSPITAL_FACILITY_SUCCESS:
      return {
        ...state,
        hospitalFacilityLoading: false,
        hospitalFacilityResponse: action.payload,
        hospitalFacilityError: null,
      };
    case hospitalData.HOSPITAL_FACILITY_FAILURE:
      return {
        ...state,
        hospitalFacilityLoading: false,
        hospitalFacilityError: action.payload,
        hospitalFacilityResponse: {},
      };
    case hospitalData.REGION_REQUEST_LIST:
      return {
        ...state,
        regionListLoading: true,
        regionListResponse: action.payload,
        regionListError: {},
      };
    case hospitalData.REGION_SUCCESS_LIST:
      return {
        ...state,
        regionListLoading: false,
        regionListResponse: action.payload,
        regionListError: {},
      };
    case hospitalData.REGION_FAILURE_LIST:
      return {
        ...state,
        regionListLoading: false,
        // regionListError: action.payload,
        regionListResponse: action.payload,
        regionListError: {},
      };
    case hospitalData.REGION_ASL_REQUEST_LIST:
      return {
        ...state,

        regionASLListLoading: true,
        regionASLListResponse: {},
        regionASLListError: {},
      };
    case hospitalData.REGION_ASL_SUCCESS_LIST:
      return {
        ...state,

        regionASLListLoading: false,
        regionASLListResponse: action.payload,
        regionASLListError: {},
      };
    case hospitalData.REGION_ASL_FAILURE_LIST:
      return {
        ...state,

        regionASLListLoading: false,
        regionASLListResponse: action.payload,
        regionASLListError: {},
      };
    case hospitalData.HOSPITAL_PHARMACY_GET_SUCCESS:
      return {
        ...state,
        pharmacyListLoading: false,
        pharmacyListResponse: action.payload,
        //   regionListResponse: {}
      };

    case hospitalData.HOSPITAL_PHARMACY_GET_REQUEST:
      return {
        ...state,
        pharmacyListLoading: false,
        // regionListError: action.payload,
        pharmacyListResponse: action.payload,
      };
    case hospitalData.HOSPITAL_PHARMACY_GET_FAILURE:
      return {
        ...state,
        pharmacyListLoading: false,
        // regionListError: action.payload,
        pharmacyListResponse: {},
      };
    // GetById
    case hospitalData.PHARMACY_REQUEST_GETBYID:
      return {
        ...state,
        pharmacyGetIdLoading: true,
        pharmacyGetIdResponse: {},
        pharmacyGetIdError: null,
      };
    case hospitalData.PHARMACY_SUCCESS_GETBYID:
      return {
        ...state,
        pharmacyGetIdLoading: false,
        pharmacyGetIdResponse: action.payload,
        pharmacyGetIdError: null,
      };
    case hospitalData.PHARMACY_FAILURE_GETBYID:
      return {
        ...state,
        pharmacyGetIdLoading: false,
        pharmacyGetIdResponse: {},
        pharmacyGetIdError: action.payload,
      };
    // pharmacy Delete
    case hospitalData.PHARMACY_REQUEST_DELETE:
      return {
        ...state,
        pharmacyDeleteLoading: true,
        pharmacyDeleteResponse: {},
        pharmacyDeleteError: null,
      };
    case hospitalData.PHARMACY_SUCCESS_DELETE:
      return {
        ...state,
        pharmacyDeleteLoading: false,
        pharmacyDeleteResponse: action.payload,
        pharmacyDeleteError: null,
      };
    case hospitalData.PHARMACY_FAILURE_DELETE:
      return {
        ...state,
        pharmacyDeleteLoading: false,
        pharmacyDeleteResponse: action.payload,
        pharmacyDeleteError: {},
      };
    // pharmacy Delete
    case hospitalData.PHARMACY_REQUEST_UPDATE:
      return {
        ...state,
        pharmacyUpdateLoading: true,
        pharmacyUpdateResponse: {},
        pharmacyUpdateError: null,
      };
    case hospitalData.PHARMACY_SUCCESS_UPDATE:
      return {
        ...state,
        pharmacyUpdateLoading: false,
        pharmacyUpdateResponse: action.payload,
        pharmacyUpdateError: null,
      };
    case hospitalData.PHARMACY_FAILURE_UPDATE:
      return {
        ...state,
        pharmacyUpdateLoading: false,
        pharmacyUpdateResponse: action.payload,
        pharmacyUpdateError: {},
      };

    case hospitalData.PHARMACY_REQUEST_CREATE:
      return {
        ...state,
        pharmacyCreateLoading: true,
        pharmacyCreateResponse: {},
        pharmacyCreateError: null,
      };
    case hospitalData.PHARMACY_SUCCESS_CREATE:
      return {
        ...state,
        pharmacyCreateLoading: false,
        pharmacyCreateResponse: action.payload,
        pharmacyCreateError: null,
      };
    case hospitalData.PHARMACY_FAILURE_CREATE:
      return {
        ...state,
        pharmacyCreateLoading: false,
        pharmacyCreateResponse: {},
        pharmacyCreateError: action.payload,
      };
    // asl creation
    case hospitalData.ASL_GET_REQUEST:
      return {
        ...state,
        aslGetLoading: true,
        aslGetResponse: {},
        aslGetError: null,
      };
    case hospitalData.ASL_GET_SUCCESS:
      return {
        ...state,
        aslGetLoading: false,
        aslGetResponse: action.payload,
        aslGetError: null,
      };
    case hospitalData.ASL_GET_FAILURE:
      return {
        ...state,
        aslGetLoading: false,
        aslGetResponse: {},
        aslGetError: action.payload,
      };
    case hospitalData.ASL_GET_CHECK:
      return {
        ...state,
        aslGetLoading: true,
        aslGetResponse: {},
        aslGetError: null,
      };
    case hospitalData.ASL_GET_CHECKSUCCESS:
      return {
        ...state,
        aslGetLoading: false,
        aslGetResponse: action.payload,
        aslGetError: null,
      };
    case hospitalData.ASL_GET_CHECkFAILURE:
      return {
        ...state,
        aslGetLoading: false,
        aslGetResponse: {},
        aslGetError: action.payload,
      };

    default:
      return state;
  }
};

export default hospitalReducer;
